<script setup lang="ts" >
import { ref, computed, onMounted, type Ref } from 'vue'

import { useFormStore } from '@/stores/form'
import { useUserStore } from '@/stores/user'

import Banner from './components/Banner.vue'
import Logo from './components/Logo.vue'
import Footerx from './components/Footerx.vue'
import MenuLside from './components/MenuLside.vue'
// Store 初始化
const userStore = useUserStore()

const formStore = useFormStore()


const agentInfo = ref(null)
const isMobile = ref(false)

interface Agent {
  name: string  
}

function getAgentInfo(agentName: string) {
  const agents: Record<string, Agent> = {
    虔智科技: { name: '虔智科技' },
    8888: { name: '歐文' },
    1674: { name: '捷仕特自動化' },
    //333: { name: '昌慧' }
  }
  const finalName = agentName || '虔智科技' // Default to 虔智科技
  const found = agents[finalName] || { name: '虔智科技' } // Fallback to default agent
  // Initialize userStore.agentInfo if null
  if (!userStore.agentInfo) {
    userStore.agentInfo = { name: '' }
  }
  userStore.agentInfo.name = found.name // Assign the string name
  return found // Return agent data
}


// 計算屬性
const CurrentForm = computed(() => formStore.TargetForm)


// onMounted( async () => {

//   await userStore.initializeStore()
//   const urlParams = new URLSearchParams(window.location.search)
//   const agentname = urlParams.get('agent')  
//   if( agentname !== null ){
//     getAgentInfo( agentname )
//   }  
// })
onMounted(async () => {
  await userStore.initializeStore()
  const urlParams = new URLSearchParams(window.location.search)
  const agentnameFromUrl = urlParams.get('agent')
  let agentname = agentnameFromUrl
  if (agentnameFromUrl !== null) {
    // 記錄到 sessionStorage（只保留這次開啟期間）
    sessionStorage.setItem('agentname', agentnameFromUrl)
  } else {
    // 從 sessionStorage 讀取（如果存在）
    agentname = sessionStorage.getItem('agentname')
  }

  if (agentname !== null) {
    getAgentInfo(agentname)
  }

  window.addEventListener('beforeunload', () => {
    sessionStorage.removeItem('agentname')
  })

})

</script>

<template>  
  <div class="app">   
    <div class="logo">
      <Logo />
    </div>
    <!-- <div v-if="agentInfo">
      <p><strong>代理商名稱：</strong>{{ agentInfo.name }}</p>
      <p><strong>聯絡方式：</strong>{{ agentInfo.contact }}</p>
    </div> -->
    <div class="banner">
      <Banner />
    </div>
    <div class="l-side">
      <MenuLside />
    </div>
    <div class="r-side">
      Ultra HD 3840 * 2160 4K 的解析度 需專用鏡頭
      
      <div class="hero">
        <h1>清晰 清晰 還是清晰 限時下殺！優惠期間月付 900</h1>
      </div>
      <div class="pricing">
        <div class="plan">
          <div class="plan-title">優惠期間月付</div>
          <div class="price"><span style="text-decoration:line-through;font-size:16px;color:#999">NT$1,200</span> NT$900 </div>
        </div>
        <div class="plan">
          <div class="plan-title">月付</div>
          <div class="price">NT$1,200 </div>
        </div>
        <div class="plan">
          <div class="plan-title">季付</div>
          <div class="price">NT$3,300 <br/>毎月只要 NT$1,100</div>
        </div>
        <div class="plan">
          <div class="plan-title">年付</div>
          <div class="price">NT$12,000 <br/>毎月只要 NT$1,000<br/>整整省 NT$2,400!</div>
        </div>
        
      
    </div>

    </div>
    <div class="main">
      <main>
        <component :is="CurrentForm" />
      </main>   
    </div>
    <div class="footer">
      <Footerx />
    </div>
  </div>
</template>

<style scoped>
.app {
  display: grid;
  background-color: black;
  color: white;
  height: 100vh;  
  font-family: Arial, Helvetica, sans-serif;
  text-align: center;
  justify-content: center; 
  align-items: center; 

  grid-template-columns: 0.2fr 1fr 1fr 0.3fr;
  grid-template-rows: 0.2fr 2.7fr 0.8fr;
  grid-template-areas: 
    "logo banner banner r-side"
    "l-side main main r-side"  
    "l-side footer footer r-side";
}

.logo {
  font-size: 22px;
  grid-area: logo;
  
}

.banner {
  grid-area: banner;
}

.l-side {
  grid-area: l-side;
  /* background-color: aqua; */
  height: 80%;

}

.r-side {
  grid-area: r-side;
}

.main {
  grid-area: main;
}

.footer {
  grid-area: footer;
}


@media screen and (max-width: 768px) {
  .app {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto auto auto;
    grid-template-areas: 
      "logo"
      "banner"
      "main"
      "footer";
    padding: 1rem;
    
    /* 縮小至 85% */
    transform: scale(0.75);
    transform-origin: top center;
  }

  .l-side,
  .r-side {
    display: none;
  }

  .logo,
  .banner,
  .main,
  .footer {
    text-align: center;
  }
}


</style>